import api from "../helpers/api";

class CountryService{

      
    async create_city(data) {
        
        return await api.post(`/cities`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response;
        });
    }
    async get_cities(page) {
        
        return await api.get(`/cities?page=${page}`,
            { headers: { "Content-Type": "application/json" } }
        )

        .then((response) => {
            return response;
        });
    }
    async update_city(data) {
        
        return await api.put(`/cities/${data.id}`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response;
        });
    }



    
   
}
export default new CountryService;